import React from 'react';
import CreateAccountComponent from '../../components/CreateAccountComponent/CreateAccountComponent';

function AccountPage() {
  return <CreateAccountComponent />;
}

export default AccountPage;
